import axios from "axios";
import { logout } from "../lib/auth";
import { followCallConfigTableColumn } from "../config/followCallConfig";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// フォローコール設定一覧
export async function getFollowCallConfigs(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "followCallConfigs";
    const params = makeParams(followCallConfigTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const followCallConfigs: dataDifine[] = response.data.fetch_data;
    const countFollowCallConfigs: string = response.data.count_data;
    return { followCallConfigs, countFollowCallConfigs };
  } catch (error) {
    // logout();
  }
}

// フォローコール設定詳細
export async function getFollowCallConfig(id: string) {
  try {
    const path = "followCallConfig";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// フォローコール設定編集
export async function putFollowCallConfig(editData: EditDataDifine) {
  try {
    const path = "followCallConfig";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// フォローコール設定登録
export async function postFollowCallConfig(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "followCallConfig";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// フォローコール設定削除
export async function deleteFollowCallConfig(id: string) {
  try {
    const path = "followCallConfig";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// フォローコール設定のコピー
export async function copyFollowCallConfig(
  id: string,
  follow_call_entry_status_conf: number | null,
  follow_call_entry_status: string,
  follow_call_base_day_conf: number | null,
  follow_call_day_offset: number | null
) {
  try {
    const path = "followCallConfig/copy";
    const bodys = {
      id,
      follow_call_entry_status_conf,
      follow_call_entry_status,
      follow_call_base_day_conf,
      follow_call_day_offset,
    };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
